import { SECTION_ROW } from './LayoutTypes';

/**
* Finds the first parent of the given item that is a section.
*/
export default function getParentSection(widgetsState, item) {
  const parent = widgetsState[item.layout.parentId];
  if (parent.layout.type === SECTION_ROW) {
    return parent;
  }
  return getParentSection(widgetsState, parent);
}
